import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ReceiveDialog({ open, onClose, onReceive }) {
  const { t } = useTranslation();
  const [source, setSource] = useState('');
  const [shipmentNumber, setShipmentNumber] = useState('');
  const [qtyReceived, setQtyReceived] = useState(0);

  const handleReceive = () => {
    onReceive({ source, shipmentNumber, qtyReceived });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="receive-dialog-title">
      <DialogTitle id="receive-dialog-title">{t('warehouse.receiveProduct', 'Receive Product')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            'warehouse.receiveProductBody',
            'Enter the information for receiving the product. If you leave the source blank, a reason will be automatically generated.',
          )}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label={t('warehouse.source', 'Source')}
          type="text"
          fullWidth
          value={source}
          onChange={e => setSource(e.target.value)}
        />
        <TextField
          margin="dense"
          label={t('warehouse.shipmentNumber', 'Shipment #')}
          type="text"
          fullWidth
          value={shipmentNumber}
          onChange={e => setShipmentNumber(e.target.value)}
        />
        <TextField
          required
          margin="dense"
          label={t('warehouse.qtyReceived', 'Qty Received')}
          type="number"
          fullWidth
          value={qtyReceived}
          onChange={e => setQtyReceived(parseInt(e.target.value, 10))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('actions.cancel', 'Cancel')}</Button>
        <Button onClick={handleReceive} color="primary" disabled={qtyReceived <= 0}>
          {t('warehouse.product.receive', 'Receive')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function PullDialog({ open, onClose, onPull }) {
  const { t } = useTranslation();
  const [quantityPulled, setQuantityPulled] = useState(0);
  const [reason, setReason] = useState('');

  const handlePull = () => {
    onPull({ quantityPulled, reason });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="pull-dialog-title">
      <DialogTitle id="pull-dialog-title">{t('warehouse.pullProduct', 'Pull Product')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('warehouse.pullProductBody', 'Enter the information for pulling the product.')}
        </DialogContentText>
        <TextField
          required
          autoFocus
          margin="dense"
          label={t('warehouse.quantityPulled', 'Quantity Pulled')}
          type="number"
          fullWidth
          value={quantityPulled}
          onChange={e => setQuantityPulled(parseInt(e.target.value, 10))}
        />
        <TextField
          required
          margin="dense"
          label={t('warehouse.reason', 'Reason')}
          type="text"
          fullWidth
          value={reason}
          onChange={e => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('actions.cancel', 'Cancel')}</Button>
        <Button onClick={handlePull} color="primary" disabled={quantityPulled <= 0}>
          {t('warehouse.product.pull', 'Pull')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
